{
  "validation.maxAttachments": "Je kunt maximaal {{max}} bijlagen toevoegen.",
  "validation.minAttachments": "Er zijn minstens {{min}} bijlagen nodig.",
  "validation.maxAttachmentSize": "Bijlagen kunnen niet groter zijn dan {{max}} megabytes.",
  "validation.attachmentListItemRequired": "Voeg een bijlage toe voor \"{{category}}\".",
  "validation.attachmentListItemMaxAttachments": "Je kunt maximaal {{max}} bijlagen toevoegen voor \"{{category}}\".",
  "validation.attachmentListItemMaxAttachmentSize": "{{category}} bijlagen kunnen niet groter zijn dan {{max}} megabytes.",
  "attachment.bsoCategory.DiagnosticReport": "Diagnoserapport",
  "attachment.bsoCategory.InvoiceDocument": "Factuur",
  "attachment.bsoCategory.ShippingDocument": "Verzenddocument",
  "attachment.bsoCategory.Letter": "Brief",
  "attachment.bsoCategory.PictureReference": "Referentie afbeelding",
  "attachment.bsoCategory.BugReport": "Bugrapport",
  "attachment.bsoCategory.Other": "Ander bestand",
  "attachment.bsoCategory.Unclassified": "Niet geclassificeerd",
  "attachment.bsoCategory.ServiceForms": "Serviceformulier",
  "attachment.bsoCategory.RegistrationDocument": "Registratiedocument",
  "attachment.bsoCategory.ShopInside": "Foto van winkelinterieur",
  "attachment.bsoCategory.ShopImageMigration": "ShopImage migratie",
  "attachment.bsoCategory.ShopImage": "Foto van voorgevel",
  "attachment.uploadButton": "{{category}} uploaden",
  "attachment.uploadDropdown": "Bestand uploaden"
}